<input
  #searchInput
  type="text"
  class="form-control"
  autocomplete="off"
  [disabled]="isDisabled"
  (keyup)="changeQuery($event)"
  (blur)="showResults()"
  (focus)="showResults()" />
<div *ngIf="showSearchResults" #results class="card search-results-list">
  <div class="card-body">
    <small>
      <em *ngIf="!data || data.length === 0">No results found</em>
    </small>
    <ul *ngIf="data && data.length > 0">
      <li *ngFor="let d of data">
        <a (click)="setValue(d.Id, d.DBA, d.Name)">
          <strong>{{ d.Id }}</strong> - {{ d.DBA || d.Name }}
        </a>
      </li>
    </ul>
  </div>
</div>
